/** Endpoints #11-#15 — groups list, create, rename/reschedule, membership, delete. */
import { z } from 'zod';
import { SCHEDULE_MODES } from '../enums.js';
/** Aggregate run state over a group's non-archived members (derived per request, never stored). */
export const GROUP_STATUSES = ['ok', 'queued', 'running', 'error'];
export const GROUP_NAME_MAX_CHARS = 100;
/** #12 `POST /api/groups` — `409 conflict` on duplicate name (NOCASE unique). */
export const CreateGroupBodySchema = z.strictObject({
    name: z.string().trim().min(1).max(GROUP_NAME_MAX_CHARS),
    memberIds: z.array(z.number().int().positive()).max(1000).optional(),
});
/** #13 `PATCH /api/groups/:id` */
export const UpdateGroupBodySchema = z
    .strictObject({
    name: z.string().trim().min(1).max(GROUP_NAME_MAX_CHARS).optional(),
    scheduleMode: z.enum(SCHEDULE_MODES).optional(),
})
    .refine((body) => body.name !== undefined || body.scheduleMode !== undefined, 'nothing to update');
/** #14 `PUT /api/groups/:id/members` — full replacement of the member set. */
export const SetGroupMembersBodySchema = z.strictObject({
    memberIds: z.array(z.number().int().positive()).max(1000),
});
//# sourceMappingURL=groups.js.map